import { put, takeEvery } from 'redux-saga/effects';
import createApiInstance from '../../services/api';
import { BASE_API_URL } from '../../config';
import {
  checkKycStatus,
  getHyperToken,
  saveHyperToken,
  validateKyc,
} from '../slices';
import { ResponseGenerator } from './common';
import { ENDPOINT } from '../../services/apiUrls';

// Dynamically create the API instance with the base URL
const api = createApiInstance(BASE_API_URL); // Replace BASE_API_URL with the dynamic value you have

/*
use when only one callback or action or both is needed
*/
function* getHyperVergeToken(actions: any) {
  try {
    const response: ResponseGenerator = yield api.get(
      ENDPOINT.THIRD_PARTY.hyperVergeKycToken(actions.payload.phone)
    );
    if (response.data) {
      yield put(saveHyperToken(response.data));
    }
  } catch (error) {
    const tokenData: any = { token: '', time: 0 };
    yield put(saveHyperToken(tokenData));
  }
}

function* validateKycHyperverge(actions: any) {
  try {
    const response: ResponseGenerator = yield api.post(
      ENDPOINT.THIRD_PARTY.hyperVergeKycValidate(actions?.payload?.phone),
      { providerTxnId: actions?.payload?.kycTransactionId }
    );
    if (response?.data?.status) {
      actions.payload.callback(true);
    } else {
      actions.payload.callback(false);
    }
  } catch {
    actions.payload.callback(false);
  }
}

function* checkKycHyperverge(actions: any) {
  try {
    const response: ResponseGenerator = yield api.get(
      ENDPOINT.THIRD_PARTY.checkHyperverge(actions?.payload?.phone),
      { params: { providerTxnId: actions?.payload?.kycTransactionId } }
    );
    if (response?.status) {
      actions.payload.callback(response.data);
    } else {
      actions.payload.callback(false);
    }
  } catch {
    actions.payload.callback(false);
  }
}

export default function* root() {
  yield takeEvery(getHyperToken.type, getHyperVergeToken);
  yield takeEvery(validateKyc.type, validateKycHyperverge);
  yield takeEvery(checkKycStatus.type, checkKycHyperverge);
}
